module.exports = __webpack_public_path__ + "static/media/edit-icon.3300cec4.svg";